import React from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Card,
  Accordion,
  OverlayTrigger,
  Modal
} from 'react-bootstrap';
import { Tooltip, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Formik } from 'formik';
import * as yup from 'yup';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import FreezeColumn from './FreezeColumn';
import fiterAPI from '../fiterAPI';

class Pulse extends React.Component {
  constructor() {
    super();
    this.state = {
      questionsObject: [],
      questionsKeys: [],
      schema: yup.object({}),
      showTooltip: false,
      showModal: false,
      succesMessage: {},
      currentPulse: undefined
    };
  }

  async componentDidMount() {
    const { roleName } = this.props.currentUser;
    this.setState({
      currentAvatar: this.props.currentInstitution.avatar[roleName]
    });
    const currPulse = await fiterAPI.getCurrentPulse();
    try {
      if (currPulse) {
        this.setState({
          currentPulse: currPulse
        });
      } else {
        this.setState({
          questionsObject: await fiterAPI.getArchetype()
        });
      }
    } catch {}

    this.setState(prevState => ({
      questionsKeys: prevState.questionsObject.map(
        (_, index) => `question-${index}`
      ),
      schema: yup.object({
        comments: yup.string(),
        ...prevState.questionsKeys.map(key => ({
          [key]: yup.string().required()
        }))
      })
    }));
    if (this.state.currentPulse)
      this.setState({
        showModal: true,
        succesMessage: {
          title: 'Parabéns, você já mediu o pulso neste mês!',
          message: []
        }
      });
  }

  onSubmit = async (answerValues, actions) => {
    try {
      this.setState({ loadingPulse: true });
      const { currentAvatar, questionsKeys, answered } = this.state;
      if (answered) return;
      // const response = await fiterAPI.savePulse(answerValues, questionsKeys);
      let happiness = 0;
      let archetype = 0;
      await fiterAPI
        .savePulse(answerValues, questionsKeys)
        .then(resp => {
          this.setState({ loadingPulse: false, answered: true });
          happiness = resp && resp.get('happiness');
          archetype = resp && resp.get('archetype');
        })
        .catch(err => {
          console.error(err);
          this.setState({ loadingPulse: false });
          Swal.fire({
            title: 'Ocorreu um erro',
            text: `Tente novamente mais tarde. \n Error: ${err}`,
            icon: 'error'
          });
        });
      // const happiness = response && response.get('happiness');
      // const archetype = response && response.get('archetype');
      this.setState({
        questionsObject: [],
        showModal: true,
        succesMessage: {
          title: `Pulso fiter medido com sucesso!`,
          message: [
            `Taxa de felicidade: ${happiness}% `,
            `Taxa de ${currentAvatar.pulse}: ${archetype}%`
          ]
        }
      });

      // Swal.fire({
      //   title: 'Dados do Pulso fiter salvos com sucesso!',
      //   html: `<p>Taxa de felicidade: ${happiness}%<p/><p></p><p>Taxa de ${currentAvatar.pulse}: ${archetype}%<p/> `,
      //   icon: 'success',
      //   onClose: () => {
      //     window.location.href = '/user';
      //   }
      // });
    } catch (err) {
      console.error(err);
      this.setState({ loadingPulse: false });
      Swal.fire({
        title: 'Ocorreu um erro',
        text: 'Tente novamente mais tarde',
        icon: 'error'
      });
    }

    actions.setSubmitting(false);
  };

  getCourseLabel = (question, currentCourse) => {
    if (question && currentCourse) {
      return question.hasVariable
        ? _.replace(question.label, '{{variable}}', currentCourse)
        : question.label;
    }
    return question ? question.label : '';
  };

  render() {
    const { currentUser, currentInstitution } = this.props;

    const {
      currentPulse,
      loadingPulse,
      questionsObject,
      schema,
      questionsKeys,
      currentAvatar,
      succesMessage
    } = this.state;
    let pulseType;
    let pulseCardHeader;
    let pulseCardText;
    let happinessText;
    let avatarPulse;
    try {
      pulseType = currentAvatar.pulseType;
      pulseCardHeader = currentAvatar.pulseCardHeader;
      pulseCardText = currentAvatar.pulseCardText;
      happinessText = currentAvatar.happinessText;
      avatarPulse = currentAvatar.pulse;
    } catch {
      pulseType = 'Pulso';
      pulseCardHeader = 'Como está nosso pulso?';
      pulseCardText =
        'Queremos te conhecer cada vez mais e criamos o pulso fiter!';
      happinessText = 'Taxa de felicidade';
      avatarPulse = 'aderência com o arquétipo';
    }
    const currentCourse = currentUser.courseLabel;
    const questions = _.get(
      questionsObject,
      currentUser.roleName,
      questionsObject || []
    );

    let happinessPercentage = 0;
    let archetypePercentage = 0;

    try {
      happinessPercentage = currentPulse.get('happiness');
      archetypePercentage = currentPulse.get('archetype');
    } catch {}

    return (
      <>
        <Modal centered show={this.state.showModal}>
          <Modal.Body>
            <div
              style={{
                height: '200px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
                alignItems: 'center'
              }}
            >
              <Typography variant="h6" style={{ textAlign: 'center' }}>
                {succesMessage?.title}
              </Typography>
              {succesMessage.message &&
                succesMessage.message.map(m => (
                  <span style={{ textAlign: 'center' }}> {m} </span>
                ))}
              <Link to="/user">
                <Button>VER MINHA LINHA DO TEMPO</Button>
              </Link>
            </div>
          </Modal.Body>
        </Modal>
        <Formik
          validationSchema={schema}
          onSubmit={this.onSubmit}
          initialValues={Object.assign(
            {},
            {
              comments: ''
            },
            ...questionsKeys.map(key => ({ [key]: '' }))
          )}
        >
          {({ handleSubmit, handleChange, values }) => (
            <Row className="border-between">
              <FreezeColumn
                title={pulseType}
                currentInstitution={currentInstitution}
              />
              <Col xs={12} md={9} className="scrollable-column">
                {currentPulse ? (
                  <Card className="mb-3 mt-3">
                    {/* <Card.Header className="main-card-header"></Card.Header> */}
                    <Card.Body>
                      <Card.Title>
                        Parabéns! Você já mediu o pulso desse mês.
                      </Card.Title>

                      <Card.Text>
                        {happinessText || 'Taxa de felicidade'}:{' '}
                        {happinessPercentage}%<br />
                        Taxa de {avatarPulse}: {archetypePercentage}%
                      </Card.Text>
                    </Card.Body>
                  </Card>
                ) : (
                  <>
                    <Card className="mb-3 mt-3">
                      {/* <Card.Header className="main-card-header"></Card.Header> */}

                      <Card.Body>
                        <Card.Title>{pulseCardHeader}</Card.Title>
                        <Card.Text>
                          {pulseCardText} <br />É simples e rápido, são 8
                          cliques e pronto!
                        </Card.Text>
                      </Card.Body>
                    </Card>
                    <Form
                      onSubmit={handleSubmit}
                      style={{ paddingBottom: '20px' }}
                    >
                      {questions.map((question, questionIndex) => (
                        <>
                          <Card className="mb-3" key={question.id}>
                            {question && question.header ? (
                              <>
                                {question?.tips &&
                                question?.tips?.length > 0 ? (
                                  <Card.Header>
                                    <>
                                      <Tooltip
                                        enterTouchDelay={0}
                                        leaveTouchDelay={9000}
                                        arrow
                                        title={question?.tips.map(qs => (
                                          <span>
                                            {qs} <p />{' '}
                                          </span>
                                        ))}
                                      >
                                        <span>
                                          <FontAwesomeIcon
                                            icon={faInfoCircle}
                                            opacity={0.5}
                                          />{' '}
                                        </span>
                                      </Tooltip>

                                      {question.header}
                                    </>
                                  </Card.Header>
                                ) : (
                                  <Card.Header>{question.header}</Card.Header>
                                )}
                              </>
                            ) : (
                              ''
                            )}
                            <Card.Body>
                              <Form.Group
                                controlId={`formQuestion-${questionIndex}`}
                                className="mb-4"
                              >
                                <Form.Label>{`${questionIndex +
                                  1} - ${this.getCourseLabel(
                                  question,
                                  currentCourse
                                )}`}</Form.Label>
                                <div className="mb-3">
                                  <fieldset>
                                    {question.answers.map(
                                      (answer, answerIndex) => (
                                        <Form.Check
                                          inline={question.layout === 'inline'}
                                          label={answer.label}
                                          type="radio"
                                          id={`inline-radio-${questionIndex}-${answerIndex}`}
                                          name={`question-${questionIndex}`}
                                          key={answer.label}
                                          value={answer.value}
                                          onChange={handleChange}
                                          required
                                        />
                                      )
                                    )}
                                  </fieldset>
                                </div>
                              </Form.Group>
                            </Card.Body>
                          </Card>
                        </>
                      ))}

                      <Form.Group controlId="formComments">
                        <Form.Label>
                          Descreva aqui uma atividade que você gostaria de fazer no seu trabalho (opcional)
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows="3"
                          name="comments"
                          value={values.comments}
                          onChange={handleChange}
                        />
                      </Form.Group>

                      {!loadingPulse ? (
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={loadingPulse}
                        >
                          Enviar
                        </Button>
                      ) : (
                        <div className="spinner-border" />
                      )}
                    </Form>
                  </>
                )}
              </Col>
            </Row>
          )}
        </Formik>
      </>
    );
  }
}

export default Pulse;
